import { joinPath } from "../../utils/string";
import { SoapService, BaseEaiwsService } from "../SoapService";
import { ArticleData, ArticleFeature, BasketColumn, BasketConfig, BasketItem, BasketServiceFault, BasketViewConfig, CalculationSheet, ChoiceList, ConditionType, ExchangeRate, ImageInfo, ItemCalculationSheet, ItemField, ItemProperties, ManufacturerInfo, MergeResult, OAPAction, OAPActionResult, OAPInteractor, PasteContainerResult, PricingProcedure, PricingProcedureDescription, PropertyValue, TaxInfo, TaxScheme, TaxSchemeDescription, TMRow, TMTable, UpdateBasketArticleResult } from "./BasketTypes";
export class BasketService extends BaseEaiwsService {
    constructor(pOwner, pBaseUrl, pSessionId) {
        super(pOwner, joinPath(pBaseUrl, "EAI/Basket"), "http://basket.ws.eai.egr/", pSessionId);
    }
    addBasketColumns(pColumns) {
        const tPromise = this.soapAjax("addBasketColumns", {
            sessionId: this.mSessionId,
            columns: pColumns
        }).then((pResponse) => {
            return (BasketColumn.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    addBasketView(pTemplate) {
        const tPromise = this.soapAjax("addBasketView", {
            sessionId: this.mSessionId,
            template: pTemplate
        }).then((pResponse) => {
            return (BasketViewConfig.FromSoap(pResponse));
        });
        return (tPromise);
    }
    addManualCondition(pItemIds, pPpName, pCondType, pOptions) {
        const tPromise = this.soapAjax("addManualCondition", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            ppName: pPpName,
            condType: pCondType,
            options: pOptions
        });
        return (tPromise);
    }
    addPriceCalculation(pPpName) {
        const tPromise = this.soapAjax("addPriceCalculation", {
            sessionId: this.mSessionId,
            ppName: pPpName
        });
        return (tPromise);
    }
    addToSetArticle(pItemIds, pOpMode) {
        const tPromise = this.soapAjax("addToSetArticle", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            opMode: pOpMode
        });
        return (tPromise);
    }
    adjustCalculationLineAmount(pItemIds, pPpName, pLevel, pCounter, pAmount, pCurrency, pOptions) {
        const tPromise = this.soapAjax("adjustCalculationLineAmount", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            ppName: pPpName,
            level: pLevel,
            counter: pCounter,
            amount: pAmount,
            currency: pCurrency,
            options: pOptions
        });
        return (tPromise);
    }
    adjustCalculationLineValue(pItemIds, pPpName, pLevel, pCounter, pValue, pCurrency, pOptions) {
        const tPromise = this.soapAjax("adjustCalculationLineValue", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            ppName: pPpName,
            level: pLevel,
            counter: pCounter,
            value: pValue,
            currency: pCurrency,
            options: pOptions
        });
        return (tPromise);
    }
    adjustConditionValue(pItemIds, pPpName, pCondType, pCounter, pValue, pCurrency, pOptions) {
        const tPromise = this.soapAjax("adjustConditionValue", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            ppName: pPpName,
            condType: pCondType,
            counter: pCounter,
            value: pValue,
            currency: pCurrency,
            options: pOptions
        });
        return (tPromise);
    }
    breakUpSetArticle(pSetArtId) {
        const tPromise = this.soapAjax("breakUpSetArticle", {
            sessionId: this.mSessionId,
            setArtId: pSetArtId
        });
        return (tPromise);
    }
    changeAlternativePositionState(pItemIds, pPpName, pAltPos, pOptions, pOptional) {
        const tPromise = this.soapAjax("changeAlternativePositionState", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            ppName: pPpName,
            altPos: pAltPos,
            options: pOptions,
            optional: pOptional
        });
        return (tPromise);
    }
    changeBasketConfig(pBasketConfig) {
        const tPromise = this.soapAjax("changeBasketConfig", {
            sessionId: this.mSessionId,
            basketConfig: pBasketConfig
        });
        return (tPromise);
    }
    changeBasketViewConfig(pViewConfig) {
        const tPromise = this.soapAjax("changeBasketViewConfig", {
            sessionId: this.mSessionId,
            viewConfig: pViewConfig
        });
        return (tPromise);
    }
    collapseSetArticles(pItemIds) {
        const tPromise = this.soapAjax("collapseSetArticles", {
            sessionId: this.mSessionId,
            itemIds: pItemIds
        });
        return (tPromise);
    }
    convertToSetArticle(pFolderId, pOpMode) {
        const tPromise = this.soapAjax("convertToSetArticle", {
            sessionId: this.mSessionId,
            folderId: pFolderId == null ? "" : pFolderId,
            opMode: pOpMode
        });
        return (tPromise);
    }
    convertToUserArticles(pItemIds, pOptions) {
        const tPromise = this.soapAjax("convertToUserArticles", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            options: pOptions
        }).then((pResponse) => {
            return (SoapService.SoapDataToArrayNU(pResponse));
        });
        return (tPromise);
    }
    copy(pItemIds, pOpMode, pUri, pOptions) {
        const tPromise = this.soapAjax("copy", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            opMode: pOpMode,
            uri: pUri == null ? "" : pUri,
            options: pOptions
        });
        return (tPromise);
    }
    deleteItems(pItemIds, pOptions) {
        const tPromise = this.soapAjax("deleteItems", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            options: pOptions
        });
        return (tPromise);
    }
    expandSetArticles(pItemIds) {
        const tPromise = this.soapAjax("expandSetArticles", {
            sessionId: this.mSessionId,
            itemIds: pItemIds
        });
        return (tPromise);
    }
    getAllChoiceLists(pItemId, pOptions) {
        const tPromise = this.soapAjax("getAllChoiceLists", {
            sessionId: this.mSessionId,
            itemId: pItemId == null ? "" : pItemId,
            options: pOptions
        }).then((pResponse) => {
            return (ChoiceList.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getAllItems(pItemIds, pOptions) {
        const tPromise = this.soapAjax("getAllItems", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            options: pOptions
        }).then((pResponse) => {
            return (BasketItem.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getArticleData(pItemId, pOptions) {
        const tPromise = this.soapAjax("getArticleData", {
            sessionId: this.mSessionId,
            itemId: pItemId == null ? "" : pItemId,
            options: pOptions
        }).then((pResponse) => {
            return (ArticleData.FromSoapNU(pResponse));
        });
        return (tPromise);
    }
    getArticleFeatures(pItemId, pOptions) {
        const tPromise = this.soapAjax("getArticleFeatures", {
            sessionId: this.mSessionId,
            itemId: pItemId == null ? "" : pItemId,
            options: pOptions
        }).then((pResponse) => {
            return (ArticleFeature.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getBasketAppData(pAppKey, pPaths) {
        const tPromise = this.soapAjax("getBasketAppData", {
            sessionId: this.mSessionId,
            appKey: pAppKey == null ? "" : pAppKey,
            paths: pPaths
        }).then((pResponse) => {
            return (SoapService.SoapDataToArrayNU(pResponse));
        });
        return (tPromise);
    }
    getBasketColumns(pColumnIds) {
        const tPromise = this.soapAjax("getBasketColumns", {
            sessionId: this.mSessionId,
            columnIds: pColumnIds
        }).then((pResponse) => {
            return (BasketColumn.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getBasketConfig() {
        const tPromise = this.soapAjax("getBasketConfig", {
            sessionId: this.mSessionId
        }).then((pResponse) => {
            return (BasketConfig.FromSoap(pResponse));
        });
        return (tPromise);
    }
    getBasketViewConfigs(pViewIds) {
        const tPromise = this.soapAjax("getBasketViewConfigs", {
            sessionId: this.mSessionId,
            viewIds: pViewIds
        }).then((pResponse) => {
            return (BasketViewConfig.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getChoiceList(pItemId, pPropClass, pPropName, pOptions) {
        const tPromise = this.soapAjax("getChoiceList", {
            sessionId: this.mSessionId,
            itemId: pItemId == null ? "" : pItemId,
            propClass: pPropClass == null ? "" : pPropClass,
            propName: pPropName == null ? "" : pPropName,
            options: pOptions
        }).then((pResponse) => {
            return (PropertyValue.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getConditionTypes(pActive, pPpName, pNames) {
        const tPromise = this.soapAjax("getConditionTypes", {
            sessionId: this.mSessionId,
            active: pActive,
            ppName: pPpName,
            names: pNames
        }).then((pResponse) => {
            return (ConditionType.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getCurrency() {
        const tPromise = this.soapAjax("getCurrency", {
            sessionId: this.mSessionId
        });
        return (tPromise);
    }
    getCurrentTaxScheme() {
        const tPromise = this.soapAjax("getCurrentTaxScheme", {
            sessionId: this.mSessionId
        });
        return (tPromise);
    }
    getExchangeRates(pCurrencies) {
        const tPromise = this.soapAjax("getExchangeRates", {
            sessionId: this.mSessionId,
            currencies: pCurrencies,
        }).then((pResponse) => {
            return (ExchangeRate.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    /**
     * @param pTimeout Deprecated - should no longer be used, use `SoapService.onGetRequestOptions` instead
     */
    getExportedGeometry(pItemId, pOptions, pTimeout) {
        const tPromise = this.soapAjax("getExportedGeometry", {
            sessionId: this.mSessionId,
            itemId: pItemId == null ? "" : pItemId,
            options: pOptions
        }, pTimeout != null ? { timeout: pTimeout } : undefined);
        return (tPromise);
    }
    getGeneratedImage(pItemId, pOptions) {
        const tPromise = this.soapAjax("getGeneratedImage", {
            sessionId: this.mSessionId,
            itemId: pItemId == null ? "" : pItemId,
            options: pOptions
        });
        return (tPromise);
    }
    getImages(pItemId, pOptions) {
        const tPromise = this.soapAjax("getImages", {
            sessionId: this.mSessionId,
            itemId: pItemId,
            options: pOptions
        }).then((pResponse) => {
            return (ImageInfo.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getItemAppData(pItemId, pAppKey, pPaths) {
        const tPromise = this.soapAjax("getItemAppData", {
            sessionId: this.mSessionId,
            itemId: pItemId == null ? "" : pItemId,
            appKey: pAppKey == null ? "" : pAppKey,
            paths: pPaths
        }).then((pResponse) => {
            return (SoapService.SoapDataToArrayNU(pResponse));
        });
        return (tPromise);
    }
    getItemFields(pItemIds, pColumnIds, pOptions) {
        const tPromise = this.soapAjax("getItemFields", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            columnIds: pColumnIds,
            options: pOptions
        }).then((pResponse) => {
            return (ItemField.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getItemProperties(pItemIds, pOptions) {
        const tPromise = this.soapAjax("getItemProperties", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            options: pOptions
        }).then((pResponse) => {
            return (ItemProperties.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    /**
     * Note: The server response will be cached to speed up further calls.
     */
    getLanguages() {
        if (this.mLanguages != null)
            return (Promise.resolve(this.mLanguages));
        const tPromise = this.soapAjax("getLanguages", {
            sessionId: this.mSessionId
        }).then((pResponse) => {
            this.mLanguages = SoapService.SoapDataToArrayNU(pResponse);
            return (this.mLanguages);
        });
        return (tPromise);
    }
    getManufacturerInfo(pItemIds, pManuIds, pSeriesIds, pOptions) {
        const tPromise = this.soapAjax("getManufacturerInfo", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            manuIds: pManuIds,
            seriesIds: pSeriesIds,
            options: pOptions
        }).then((pResponse) => {
            return (ManufacturerInfo.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getPriceCalculationSheet(pItemIds, pPpName, pOptions) {
        const tPromise = this.soapAjax("getPriceCalculationSheet", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            ppName: pPpName,
            options: pOptions
        }).then((pResponse) => {
            return (CalculationSheet.FromSoapNU(pResponse));
        });
        return (tPromise);
    }
    getPriceCalculationSheets(pItemIds, pPpName, pOptions) {
        const tPromise = this.soapAjax("getPriceCalculationSheets", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            ppName: pPpName,
            options: pOptions
        }).then((pResponse) => {
            return (ItemCalculationSheet.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getPricingProcedure(pActive, pName) {
        const tPromise = this.soapAjax("getPricingProcedure", {
            sessionId: this.mSessionId,
            active: pActive,
            name: pName
        }).then((pResponse) => {
            return (PricingProcedure.FromSoapNU(pResponse));
        });
        return (tPromise);
    }
    getReferenceCurrency() {
        const tPromise = this.soapAjax("getReferenceCurrency", {
            sessionId: this.mSessionId
        });
        return (tPromise);
    }
    getTaxInformation(pItemId) {
        const tPromise = this.soapAjax("getTaxInformation", {
            sessionId: this.mSessionId,
            itemId: pItemId
        }).then((pResponse) => {
            return (TaxInfo.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getTaxScheme(pActive, pSchemeId) {
        const tPromise = this.soapAjax("getTaxScheme", {
            sessionId: this.mSessionId,
            active: pActive,
            schemeId: pSchemeId
        }).then((pResponse) => {
            return (TaxScheme.FromSoapNU(pResponse));
        });
        return (tPromise);
    }
    getTopFolderId(pViewId) {
        const tPromise = this.soapAjax("getTopFolderId", {
            sessionId: this.mSessionId,
            viewId: pViewId
        });
        return (tPromise);
    }
    insertFolder(pFatherId, pBeforeId, pName) {
        const tPromise = this.soapAjax("insertFolder", {
            sessionId: this.mSessionId,
            fatherId: pFatherId == null ? "" : pFatherId,
            beforeId: pBeforeId == null ? "" : pBeforeId,
            name: pName
        });
        return (tPromise);
    }
    insertTextItem(pFatherId, pBeforeId, pText) {
        const tPromise = this.soapAjax("insertTextItem", {
            sessionId: this.mSessionId,
            fatherId: pFatherId == null ? "" : pFatherId,
            beforeId: pBeforeId == null ? "" : pBeforeId,
            text: pText
        });
        return (tPromise);
    }
    insertUserArticle(pFatherId, pBeforeId, pShortText) {
        const tPromise = this.soapAjax("insertUserArticle", {
            sessionId: this.mSessionId,
            fatherId: pFatherId == null ? "" : pFatherId,
            beforeId: pBeforeId == null ? "" : pBeforeId,
            shortText: pShortText
        });
        return (tPromise);
    }
    insertOFMLArticle(pFatherId, pBeforeId, pInsertInfo, pOptions) {
        const tPromise = this.soapAjax("insertOFMLArticle", {
            sessionId: this.mSessionId,
            fatherId: pFatherId == null ? "" : pFatherId,
            beforeId: pBeforeId == null ? "" : pBeforeId,
            insertInfo: pInsertInfo,
            options: pOptions
        });
        return (tPromise);
    }
    listPricingProcedures(pActive) {
        const tPromise = this.soapAjax("listPricingProcedures", {
            sessionId: this.mSessionId,
            active: pActive
        }).then((pResponse) => {
            return (PricingProcedureDescription.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    listTaxSchemes(pActive, pCountry) {
        const tPromise = this.soapAjax("listTaxSchemes", {
            sessionId: this.mSessionId,
            active: pActive,
            country: pCountry
        }).then((pResponse) => {
            return (TaxSchemeDescription.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    mergeBasketArticles(pItemIds, pOptions) {
        const tPromise = this.soapAjax("mergeBasketArticles", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            options: pOptions
        }).then((pResponse) => {
            return (MergeResult.FromSoapNU(pResponse));
        });
        return (tPromise);
    }
    moveItems(pItemIds, pDirection) {
        const tPromise = this.soapAjax("moveItems", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            direction: pDirection
        });
        return (tPromise);
    }
    oapGetActionData(pItemId, pActionId, pDpr, pInteractor) {
        const tPromise = this.soapAjax("oapGetActionData", {
            sessionId: this.mSessionId,
            itemId: pItemId,
            actionId: pActionId,
            dpr: pDpr,
            interactor: pInteractor
        }).then((pResponse) => {
            return (OAPAction.FromSoap(pResponse));
        });
        return (tPromise);
    }
    //TODO: typings for oapGetArticleData
    /*public oapGetArticleData(pItemId: string): Promise<any>
    {
        let tPromise = this.soapAjax(
            "oapGetArticleData",
            {
                sessionId: this.mSessionId,
                itemId: pItemId
            }
        ).then((pResponse) =>
        {
            return (pResponse);
        });
        return (tPromise);
    }*/
    oapGetInteractors(pItemId, pInteractorIds, pDpr) {
        const tPromise = this.soapAjax("oapGetInteractors", {
            sessionId: this.mSessionId,
            itemId: pItemId,
            interactorIds: pInteractorIds,
            dpr: pDpr
        }).then((pResponse) => {
            return (OAPInteractor.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    oapProcessActions(pActionIds, pExec, pContext) {
        const tPromise = this.soapAjax("oapProcessActions", {
            sessionId: this.mSessionId,
            actionIds: pActionIds,
            exec: pExec,
            context: pContext
        }).then((pResponse) => {
            return (OAPActionResult.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    oapSetClientCapabilities(pCapabilities) {
        const tPromise = this.soapAjax("oapSetClientCapabilities", {
            sessionId: this.mSessionId,
            capabilities: pCapabilities
        });
        return (tPromise);
    }
    paste(pFatherId, pBeforeId, pUri, pOptions) {
        const tPromise = this.soapAjax("paste", {
            sessionId: this.mSessionId,
            fatherId: pFatherId == null ? "" : pFatherId,
            beforeId: pBeforeId == null ? "" : pBeforeId,
            uri: pUri,
            options: pOptions
        }).then((pResponse) => {
            return (SoapService.SoapDataToArrayNU(pResponse));
        });
        return (tPromise);
    }
    pasteContainer(pFatherId, pBeforeId, pUri, pOptions) {
        const tPromise = this.soapAjax("pasteContainer", {
            sessionId: this.mSessionId,
            fatherId: pFatherId == null ? "" : pFatherId,
            beforeId: pBeforeId == null ? "" : pBeforeId,
            uri: pUri,
            options: pOptions
        }).then((pResponse) => {
            return (PasteContainerResult.FromSoap(pResponse));
        });
        return (tPromise);
    }
    relocateItems(pFatherId, pBeforeId, pItemIds, pOptions) {
        const tPromise = this.soapAjax("relocateItems", {
            sessionId: this.mSessionId,
            fatherId: pFatherId == null ? "" : pFatherId,
            beforeId: pBeforeId == null ? "" : pBeforeId,
            itemIds: pItemIds,
            options: pOptions
        });
        return (tPromise);
    }
    removeBasketColumns(pColumnIds) {
        const tPromise = this.soapAjax("removeBasketColumns", {
            sessionId: this.mSessionId,
            columnIds: pColumnIds
        });
        return (tPromise);
    }
    removeBasketViews(pViewIds) {
        const tPromise = this.soapAjax("removeBasketViews", {
            sessionId: this.mSessionId,
            viewIds: pViewIds
        });
        return (tPromise);
    }
    removeCondition(pItemIds, pPpName, pCondType, pCounter, pOptions) {
        const tPromise = this.soapAjax("removeCondition", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            ppName: pPpName,
            condType: pCondType,
            counter: pCounter,
            options: pOptions
        });
        return (tPromise);
    }
    removeFromSetArticle(pItemIds, pOpMode) {
        const tPromise = this.soapAjax("removeFromSetArticle", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            opMode: pOpMode
        });
        return (tPromise);
    }
    resetConditionAmount(pItemIds, pPpName, pCondType, pCounter, pOptions) {
        const tPromise = this.soapAjax("resetConditionAmount", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            ppName: pPpName,
            condType: pCondType,
            counter: pCounter,
            options: pOptions
        });
        return (tPromise);
    }
    resetItemFields(pItemIds, pColumnId, pData, pOptions) {
        const tPromise = this.soapAjax("resetItemFields", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            columnId: pColumnId,
            data: pData,
            options: pOptions
        });
        return (tPromise);
    }
    resetQuantityRelation(pItemIds, pPpName, pCondType, pCounter, pOptions) {
        const tPromise = this.soapAjax("resetQuantityRelation", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            ppName: pPpName,
            condType: pCondType,
            counter: pCounter,
            options: pOptions
        });
        return (tPromise);
    }
    resetTaxConfiguration() {
        const tPromise = this.soapAjax("resetTaxConfiguration", {
            sessionId: this.mSessionId
        });
        return (tPromise);
    }
    resetTaxScheme(pSchemeId) {
        const tPromise = this.soapAjax("resetTaxScheme", {
            sessionId: this.mSessionId,
            schemeId: pSchemeId
        });
        return (tPromise);
    }
    resetTaxRate(pSchemeId, pTypeId, pCategoryId) {
        const tPromise = this.soapAjax("resetTaxRate", {
            sessionId: this.mSessionId,
            schemeId: pSchemeId,
            typeId: pTypeId,
            categoryId: pCategoryId
        });
        return (tPromise);
    }
    selectCurrentTaxScheme(pSchemeId) {
        const tPromise = this.soapAjax("selectCurrentTaxScheme", {
            sessionId: this.mSessionId,
            schemeId: pSchemeId
        });
        return (tPromise);
    }
    setBasketAppData(pAppKey, pData) {
        const tPromise = this.soapAjax("setBasketAppData", {
            sessionId: this.mSessionId,
            appKey: pAppKey == null ? "" : pAppKey,
            data: pData
        });
        return (tPromise);
    }
    setBasketColumnProperties(pColumns) {
        const tPromise = this.soapAjax("setBasketColumnProperties", {
            sessionId: this.mSessionId,
            columns: pColumns
        });
        return (tPromise);
    }
    setConditionAmount(pItemIds, pPpName, pCondType, pCounter, pAmount, pCurrency, pOptions) {
        const tPromise = this.soapAjax("setConditionAmount", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            ppName: pPpName,
            condType: pCondType,
            counter: pCounter,
            amount: pAmount,
            currency: pCurrency,
            options: pOptions
        });
        return (tPromise);
    }
    setConditionDescription(pPpName, pCondType, pLang, pDescription) {
        const tPromise = this.soapAjax("setConditionDescription", {
            sessionId: this.mSessionId,
            ppName: pPpName,
            condType: pCondType,
            lang: pLang,
            description: pDescription
        });
        return (tPromise);
    }
    setCurrency(pCurrency) {
        const tPromise = this.soapAjax("setCurrency", {
            sessionId: this.mSessionId,
            currency: pCurrency == null ? "" : pCurrency
        });
        return (tPromise);
    }
    setExchangeRates(pExchangeRates) {
        const tPromise = this.soapAjax("setExchangeRates", {
            sessionId: this.mSessionId,
            exchangeRates: pExchangeRates,
        });
        return (tPromise);
    }
    setItemAppData(pItemId, pAppKey, pData) {
        const tPromise = this.soapAjax("setItemAppData", {
            sessionId: this.mSessionId,
            itemId: pItemId == null ? "" : pItemId,
            appKey: pAppKey == null ? "" : pAppKey,
            data: pData
        });
        return (tPromise);
    }
    setItemConditionDescription(pItemIds, pPpName, pCondType, pCounter, pLang, pDescription, pOptions) {
        const tPromise = this.soapAjax("setItemConditionDescription", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            ppName: pPpName,
            condType: pCondType,
            counter: pCounter,
            lang: pLang,
            description: pDescription,
            options: pOptions
        });
        return (tPromise);
    }
    setItemFields(pFields) {
        const tPromise = this.soapAjax("setItemFields", {
            sessionId: this.mSessionId,
            fields: pFields,
        });
        return (tPromise);
    }
    setItemProperties(pItemId, pProperties) {
        const tPromise = this.soapAjax("setItemProperties", {
            sessionId: this.mSessionId,
            itemId: pItemId == null ? "" : pItemId,
            properties: pProperties == null ? new ItemProperties() : pProperties
        });
        return (tPromise);
    }
    setLanguages(pLanguages, pMode) {
        const tPromise = this.soapAjax("setLanguages", {
            sessionId: this.mSessionId,
            languages: pLanguages,
            mode: pMode
        }).then(() => {
            this.mLanguages = undefined;
            this.mOwner.eventBasketLanguagesChanged.trigger();
        });
        return (tPromise);
    }
    setPropertyValue(pItemId, pPropClass, pPropName, pValue, pOptions) {
        const tPromise = this.soapAjax("setPropertyValue", {
            sessionId: this.mSessionId,
            itemId: pItemId,
            propClass: pPropClass,
            propName: pPropName,
            value: pValue == null ? "" : pValue,
            options: pOptions
        });
        return (tPromise);
    }
    setQuantityRelation(pItemIds, pPpName, pCondType, pCounter, pQuantity, pUnit, pOptions) {
        const tPromise = this.soapAjax("setQuantityRelation", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            ppName: pPpName,
            condType: pCondType,
            counter: pCounter,
            quantity: pQuantity,
            unit: pUnit,
            options: pOptions
        });
        return (tPromise);
    }
    setTaxInformation(pItemId, pTaxType, pTaxCategory) {
        const tPromise = this.soapAjax("setTaxInformation", {
            sessionId: this.mSessionId,
            itemId: pItemId,
            taxType: pTaxType,
            taxCategory: pTaxCategory
        });
        return (tPromise);
    }
    setTaxRate(pSchemeId, pTypeId, pCategoryId, pRate) {
        const tPromise = this.soapAjax("setTaxRate", {
            sessionId: this.mSessionId,
            schemeId: pSchemeId,
            typeId: pTypeId,
            categoryId: pCategoryId,
            rate: pRate
        });
        return (tPromise);
    }
    startOFMLDebugging(pDebugModes, pTraceLevel, pDetailLevel, pOutputDevice, pDebugClasses) {
        const tPromise = this.soapAjax("startOFMLDebugging", {
            sessionId: this.mSessionId,
            debugModes: pDebugModes,
            traceLevel: pTraceLevel,
            detailLevel: pDetailLevel,
            outputDevice: pOutputDevice,
            debugClasses: pDebugClasses
        });
        return (tPromise);
    }
    stopOFMLDebugging() {
        const tPromise = this.soapAjax("stopOFMLDebugging", {
            sessionId: this.mSessionId,
        });
        return (tPromise);
    }
    tmGetTable(pViewId, pItemId) {
        const tPromise = this.soapAjax("tmGetTable", {
            sessionId: this.mSessionId,
            viewId: pViewId,
            itemId: pItemId
        }).then((pResponse) => {
            return (TMTable.FromSoap(pResponse));
        });
        return (tPromise);
    }
    tmGetText(pViewId, pItemId, pAllLanguages, pEnableLangTags) {
        const tPromise = this.soapAjax("tmGetText", {
            sessionId: this.mSessionId,
            viewId: pViewId,
            itemId: pItemId,
            allLanguages: pAllLanguages,
            enableLangTags: pEnableLangTags
        }).then((pResponse) => {
            return (TMRow.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    tmSetText(pViewId, pItemId, pTextId, pLang, pText) {
        const tPromise = this.soapAjax("tmSetText", {
            sessionId: this.mSessionId,
            viewId: pViewId,
            itemId: pItemId,
            textId: pTextId,
            lang: pLang,
            text: pText
        });
        return (tPromise);
    }
    tmSetTextVisibility(pViewId, pItemId, pTextId, pVisible) {
        const tPromise = this.soapAjax("tmSetTextVisibility", {
            sessionId: this.mSessionId,
            viewId: pViewId,
            itemId: pItemId,
            textId: pTextId,
            visible: pVisible
        });
        return (tPromise);
    }
    updateBasketArticles(pItemIds, pCatalogIds, pOptions) {
        const tPromise = this.soapAjax("updateBasketArticles", {
            sessionId: this.mSessionId,
            itemIds: pItemIds,
            catalogIds: pCatalogIds,
            options: pOptions
        }).then((pResponse) => {
            return (UpdateBasketArticleResult.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _clearCache() {
        this.mLanguages = undefined;
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    getErrorDetail(pSoapData) {
        const tFault = pSoapData["ns2:BasketServiceFault"];
        return (tFault != null ? BasketServiceFault.FromSoap(tFault) : undefined);
    }
}
